import { isGlobalSettingsMailbox } from "owa-account-source-list-store";
import { isCapabilityEnabled, type Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { isConsumer } from "owa-session-store";

const copilotAsyncChatCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        return !!mailboxInfo && isAccountFeatureEnabled("copilot-async-chat", mailboxInfo);
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (!!mailboxInfo &&
            !isConsumer(undefined /* smtpAddress */, mailboxInfo) &&
            isGlobalSettingsMailbox(mailboxInfo));
    },
};

export function isCopilotAsyncChatEnabled(mailboxInfo: MailboxInfo): boolean {
    return isCapabilityEnabled(copilotAsyncChatCapability, mailboxInfo);
}
